import axios from 'axios';

export default class NodeService {
  getTreeTableNodes(file) {
    console.log('FILE#',file);
    return axios.get(file)
      .then((res) => res.data.root);
  }
}
